import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';
import { FacilitatorList } from '../interfaces/facilitator.interface';
import { Agency } from '../components/agency/agency-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class FacilitatorserviceService {
  public eventSearch$ = new EventEmitter<string>();
  private urlProd: string = environment.apiRoot;
  private _refresrequired = new Subject<void>();

  constructor(private http: HttpClient) {}

  get Refreshrequired() {
    return this._refresrequired;
  }

  public emitSearchFacilitator(search: string): void {
    return this.eventSearch$.emit(search);
  }

  public filterByStatus$ = new EventEmitter<string>();

  public filteringByStatus(filtering: string): void {
    this.filterByStatus$.emit(filtering);
  }

  public getAllFacilitators(
    search: string,
    page: number,
    limit: number,
    id_allied: string,
    sort?: any
  ): Observable<FacilitatorList> {
    return this.http.get<FacilitatorList>(
      `${this.urlProd}facilitator/list-facilitator`,
      {
        params: {
          search,
          page,
          limit,
          sort,
          id_allied,
        },
        context: checkToken(),
      }
    );
  }

  public facilitatorsList(status: string, alliedId: string, page: number, limit: number, sortField: string, sortDirection: string, searchValue?: string, searchTerm: string = "name") {
    let baseUrl = new URL(`${this.urlProd}facilitator/paged-list-facilitator?id_allied=${alliedId}&page=${page}&limit=${limit}`);

    let searchParams = baseUrl.searchParams;
    if (status && status !== 'all') {
      searchParams.set('status', status);
    }

    if (sortField) {
      searchParams.set('sortField', sortField);
    }

    if (sortDirection) {
      searchParams.set('sortDirection', sortDirection);
    }

    if (searchTerm && searchValue) {
      searchParams.set('searchTerm', searchTerm);
      searchParams.set('searchValue', searchValue);
    }

    return this.http.get(
      baseUrl.toString(),
      { context: checkToken() }
    );
  }

  getFacilitator(id: string) {
    return this.http.get(
      `${this.urlProd}facilitator/detail-facilitator?id_facilitator=${id}`,
      { context: checkToken() }
    );
  }

  listAgencies() {
    return this.http.get(
      `${this.urlProd}facilitator/list-agencies`,
      { context: checkToken() }
    );
  }

  getAgencies(page: number, limit: number, sortField: string, sortDirection: string, searchValue?: string, searchTerm: string = "name") {
    let baseUrl = new URL(`${this.urlProd}facilitator/agencies?page=${page}&limit=${limit}`);
    let searchParams = baseUrl.searchParams;
    if (sortField) {
      searchParams.set('sortField', sortField);
    }

    if (sortDirection) {
      searchParams.set('sortDirection', sortDirection);
    }

    if (searchTerm && searchValue) {
      searchParams.set('searchTerm', searchTerm);
      searchParams.set('searchValue', searchValue);
    }

    return this.http.get(
      baseUrl.toString(),
      { context: checkToken() }
    );
  }

  addAgency(agency: Agency) {
    return this.http
      .post(
        `${this.urlProd}facilitator/agency`,
        agency,
        { context: checkToken() }
      );
  }

  updateAgency(agency: Agency) {
    return this.http
      .put(
        `${this.urlProd}facilitator/agency`,
        agency,
        { context: checkToken() }
      );
  }

  deleteAgency(id: string) {
    return this.http
      .delete(
        `${this.urlProd}facilitator/agency?id=${id}`,
        { context: checkToken() }
      );
  }

  addFacilitator(id_allied: string, body: any) {
    return this.http
      .post(
        `${this.urlProd}facilitator/add-facilitator?id_allied=${id_allied}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  editFacilitator(id_facilitator: string, body: any) {
    return this.http
      .put(
        `${this.urlProd}facilitator/edit-facilitator?id_facilitator=${id_facilitator}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  deleteFacilitator(id_facilitator: string) {
    return this.http
      .delete(
        `${this.urlProd}facilitator/delete-facilitator?id_facilitator=${id_facilitator}`,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  ressetPassword(email: string, id: string) {
    return this.http.post(
      `${this.urlProd}facilitator/forward-password?id_facilitator=${id}`,
      { email: email },
      { context: checkToken() }
    );
  }

  getQrToken(payload: {
    allied_id: string;
    group_id: string;
    facilitator_id: string;
    id: string;
  }) {
    return this.http.post<{ token: string; url: string; expires_at?: string }>(
      `${this.urlProd}facilitator/qr-token`,
      payload,
      { context: checkToken() }
    );
  }

  resendQrEmail(idFacilitator: string, groupId: string, email: string) {
    return this.http.post(
      `${this.urlProd}facilitator/resend-qr-email?id_facilitator=${idFacilitator}&group_id=${groupId}`,
      { email },
      { context: checkToken() }
    );
  }

  transferFacilitator(id: string, body: any) {
    return this.http
      .patch(
        `${this.urlProd}facilitator/transfer-facilitator?id_facilitator=${id}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  getDataDahsboard(id: string) {
    return this.http
      .get(
        `${this.urlProd}/facilitator/facilitator-dashboard?id_allied=${id}`,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }
}
